import {Component, Input} from '@angular/core';
import {EventPreview} from "../../interfaces/event-preview";

@Component({
  selector: 'brt-event-mini-preview',
  templateUrl: './event-mini-preview.component.html',
  styleUrls: ['./event-mini-preview.component.scss']
})
export class EventMiniPreviewComponent {

  @Input('data') eventPreview!: EventPreview;

  getAppointmentDatesText(appointments: {
    startTime: string;
    endTime: string;
    startDate: string;
    endDate: string;
    note: {
      link: string,
      firstname: string,
      lastname: string,
      phone: string,
      email: string,
      remark: string
    };
    bookableUntil: string;
    maxParticipants: number;
    appointmentType: string;
    appointmentState: string;
    bookingLink: string
  }[]) {

    let dateStrings: string[] = [];

    appointments.forEach(appointment => {
      let dateString = "";
      dateString += appointment.startDate;

      if(appointment.endDate.length) {
        dateString += ' - ' + appointment.endDate;
      }

      dateStrings.push(dateString);

    });

    return dateStrings.join(", ");

  }


}
